module.exports = __webpack_public_path__ + "static/img/cou.13b56e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/logo/cou.jpg
// module id = bbNR
// module chunks = 0